<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">字典配置</span>
    </div>
    <div style="padding:20px 20px 0px 24px">
      <ul class="dictionaryul">
        <li v-for="(item, index) in dictionariesArr" :key="item.model">
          <div style="margin-bottom:20px">
            <el-button
              icon="iconfont icon-add"
              @click="add_dictionaries(item.model,{})"
              type="submit"
              >新增{{ item.label }}</el-button
            >
          </div>
          <x-table
            url="/pc/dictionary/page"
            :ref="item.model"
            max-height="710"
            :params="{ defType: item.model }"
            :columnArr="[{ label: '资产' + item.label, model: 'defValue' }]"
          >
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="add_dictionaries(item.model,scope.row)"
                  icon="iconfont icon-edit"
                  class="addColor"
                ></el-button>
                <el-button
                  type="text"
                  @click.stop="
                    $axiosDelete(
                      '/pc/dictionary/del',
                      { id: scope.row.id },
                      tableSearch,
                      item.model,true
                    )
                  "
                  icon="iconfont icon-delete"
                  class="deleteColor"
                ></el-button>
              </template>
            </el-table-column>
          </x-table>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dictionariesArr: [
        {
          label: "目录",
          model: "catalogue",
        },
        {
          label: "来源",
          model: "source",
        },
        {
          label: "单位",
          model: "unit",
        },
        {
          label: "类型",
          model: "dispose",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    dictionaries_Type(data) {
      let str = "";
      switch (data) {
        case "catalogue":
          str = "目录";
          break;
        case "source":
          str = "来源";
          break;
        case "unit":
          str = "单位";
          break;
        case "dispose":
          str = "类型";
          break;
      }
      return str;
    },
    add_dictionaries(defType, item) {
      this.$createDialog(this, {
        dialogConfig: {
          title: item.id
            ? "字典" + this.dictionaries_Type(item.defType) + "编辑"
            : "字典" + this.dictionaries_Type(defType) + "新增",
          width: "360px",
        },
        namespace: "sys_add_dictionaries",
        whetherDestruction: true,

        assemblyConfig: {
          row:item,
          defType,
          callBack: this.tableSearch,
          dictionaries_Type: this.dictionaries_Type,
        },
      });
    },
    tableSearch(refName) {
      this.$refs[refName][0].search();
    },
  },
};
</script>
<style scoped>
ul,
li {
  margin: 0;
  padding: 0;
}
.dictionaryul {
  display: flex;
  flex-direction: row;
  overflow: auto;
}
.dictionaryul li {
  width: 360px;
  margin-right: 34px;
}
.dictionaryul li:last-child {
  margin-right: 0;
}
</style>
